import { useCallback, useRef, type PointerEvent } from 'react';

const LAYERS = 14; // khớp số lớp trong glow.css

/**
 * Lớp chấm sáng theo con trỏ. Gắn `onPointerMove` trả về lên phần tử gốc có class `hana-glow-root`.
 * Không dùng state: chỉ ghi --mx/--my lên lớp glow, nên rê chuột không render lại React.
 */
export function useGlow() {
  const ref = useRef<HTMLDivElement>(null);
  const onPointerMove = useCallback((e: PointerEvent<HTMLElement>) => {
    const g = ref.current;
    if (!g || e.pointerType === 'touch') return;
    const r = e.currentTarget.getBoundingClientRect();
    g.style.setProperty('--mx', `${Math.round(e.clientX - r.left)}px`);
    g.style.setProperty('--my', `${Math.round(e.clientY - r.top)}px`);
  }, []);
  const layer = (
    <div ref={ref} className="hana-glow" aria-hidden="true">
      <b />
      {Array.from({ length: LAYERS }, (_, i) => (
        <i key={i} />
      ))}
    </div>
  );
  return { onPointerMove, layer };
}
